module.exports = __webpack_public_path__ + "static/media/205-marshall-island.cb56972d.svg";